// extracted by mini-css-extract-plugin
module.exports = {"button":"_2S87e","medium":"_2Cs7X","text":"_2uX6I","icon":"G3Pzl"};